<template>
  <div class="integration-card-view">
    <table>
      <thead>
      <tr style="background-color: #F4F5F7">
        <th>Вакансия на {{integration === 'avito-integrations'? 'Avito' : 'hh' }}</th>
        <th>Адрес</th>
        <th style="white-space: nowrap;">Менеджер вакансии</th>
        <th></th> <!-- Пустой заголовок -->
      </tr>
      </thead>
      <tbody>
      <tr :key="index" v-for="(item, index) in items">
        <td class="url" style="width: 220px">
          <a  class="link-text" :href="item.url" target="_blank">{{ item.title }}</a>
        </td>
        <td style="width: 316px">{{ item.address }}</td>
        <td style="width: 225px">{{ item.hr.full_name }}</td>
        <td class="integration-card-view__menu-btn">
          <Trash @click="deleteIntegration(item)" class=" ml-auto"/>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import Pencil from "@/components/Icons/Pencil.vue";
import { onMounted, onUnmounted, ref } from "vue";
import ThreeDots from "@/components/Icons/ThreeDots.vue";
import Trash from "@/components/Icons/Trash.vue";

const emit = defineEmits(["delete"]);

const props = defineProps({
  items: Array,
  integration: String,
});

const showMenu = ref(false);
const menuRef = ref(null);

// Функция для переключения меню
const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

// Функция для закрытия меню при клике вне его области
const handleClickOutside = (event) => {
  if (menuRef.value && !menuRef.value.contains(event.target)) {
    showMenu.value = false;
  }
};

// Добавляем обработчик клика при монтировании компонента
onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

// Удаляем обработчик при размонтировании компонента
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

const deleteIntegration = (row) => {
  emit("delete", props.integration, (row?.id || row?.hh_vacancy_id));
}
</script>

<style scoped lang="scss">
.integration-card-view {
  width: 100%;
  font-size: 14px;
  margin: 20px 0;
  font-family: Arial, sans-serif;
  z-index: 0;

  table {
    width: 100%;
    border-collapse: collapse;

    th, td {
      padding:  16px 24px;
      text-align: left;
      border-bottom: 1px solid #F4F5F7;
    }

    th {
      font-weight: 400;
      color: $grey-pressed;

      &:last-child {
        opacity: 0; /* Скрываем пустой заголовок */
      }
    }

    .url {
      a {
        color: $primary-main!important;
      }
    }

    // Стили для последней строки
    tr.last-row {
      td {
        border-bottom: none;
        padding-bottom: 16px;
      }
    }
  }

  &__menu {
    position: absolute;
    right: -130px;
    top: 36px;
    z-index: 2;
    width: 174px;
    padding: 8px 12px;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid $light-gray-1;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
  }

  &__menu-btn {
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    user-select: none;
    cursor: pointer;
    color: $red;
  }

  &__dots-btn {
    width: 20px;
    height: 20px;
    margin-left: auto;
    cursor: pointer;
  }

  &__dots-icon {
    width: 20px;
  }
}

.menu {
  display: flex;
  position: relative;
  justify-content: space-between;
}
</style>